module.exports = __webpack_public_path__ + "img/a.8b2cd733.svg";